import React from 'react';
import PropTypes from 'prop-types';

import Category, { CategoryModelPropTypes } from './category';

class Categories extends React.Component {
    static propTypes = {
        data: PropTypes.arrayOf(PropTypes.shape(CategoryModelPropTypes))
            .isRequired,
        selected_category_id: PropTypes.number,
    };

    constructor(...args) {
        super(...args);

        this.category_nodes = {};
    }

    getCategoryNodes = () => this.category_nodes;

    render = () => {
        this.category_nodes = {};
        return this.props.data.map(category => (
            <Category
                key={category.id}
                entity={category}
                is_selected={category.id === this.props.selected_category_id}
                ref={e => (this.category_nodes[category.id] = e)}
            />
        ));
    };
}

export default Categories;
